<template>
	<section v-if="items.length" class="faq-section">
		<div class="row faq">
			<div class="columns column12">
				<div class="columns column12">
					<h2>{{ header }}</h2>
					<div class="collapse-container">
						<collapse v-for="item in items" :key="item.ID" :header="item.question" :content="item.answer" />
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.faq-section {
	background-color: var(--primary-background-color);
	padding: 0 0 100px;

	h2 {
		margin-bottom: 50px;
	}

	h4 {
		font-family: var(--button-font-family) !important;
	}

	.collapse-container {
		background-color: var(--secondary-background-color);
	}
}
</style>
